import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-street-light-planner-step4',
  templateUrl: './street-light-planner-step4.component.html',
  styleUrls: [],
})
export class StreetLightPlannerStep4Component {
  @Input() isReused: boolean | null = null;
  @Output() isReusedValueChange = new EventEmitter();

  select(value: boolean) {
    this.isReused = value;
    this.isReusedValueChange.emit(this.isReused);
  }
}
